import { gql } from '@apollo/client';

export const GetLocationsQuery = gql`
    query GetLocations($regionId: ID!) {
        getLocations(regionId: $regionId) {
            id
            name
        }
    }
`;
